import React from "react";

import { getNumberDayMonthYear } from "~/libs/getDateOptions";

import SrrRowBase from "./SrrRowBase";

const ReportNSByOldClients = ({ row, items }) => {
  const renderItem = [
    row.dealer.DealerName,
    row.dealer.city,
    row.dealer.INN,
    row.dealer.filial,
    row.dealer.entfCode,
    row.dealer.subject,
    row.dealer.FO,
    row.dealer.status === "active" ? "1" : "0",
    row.carsTotal,
    row.carModel,
    row.car ? row.car.eqVariant : "",
    row.car ? row.car.eqNumber : "",
    row.car ? row.car.vin : "",
    row.sellDate ? getNumberDayMonthYear({ date: row.sellDate }) : "",
    row.ownershipPeriod,
    row.ownerChangeDate,
    row.carSaleDate,
    row.newCarDate ? getNumberDayMonthYear({ date: row.newCarDate }) : "",
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportNSByOldClients;
